module.exports = __webpack_public_path__ + "img/dsci0111.0e560512.jpg";